import { BounceLoader } from 'react-spinners';
import React from 'react';

export const SpinLoader = () => (
    <BounceLoader
        css={{
            margin: '30px auto'
        }}
        color={'#2B5BE2'}
    />
);
